import { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";

const ROTATING_WORDS = [
  "DevOps",
  "CI/CD Pipelines",
  "Cloud Infrastructure",
  "Kubernetes",
  "Terraform & IaC",
  "FinOps",
  "Observability",
  "AI Agent Systems",
  "Microservices",
  "Platform Engineering",
];

const FLOATING_TAGS = [
  // DevOps & Cloud
  "", "Kubernetes", "Docker", "Terraform", "AWS", "GCP", "Azure",
  "ArgoCD", "Jenkins", "GitHub Actions", "Helm", "Vault", "Istio",
  "Prometheus", "Grafana", "Datadog", "Pulumi", "Ansible", "ELK",
  // AI / LLM
  "LangGraph","Claude", "RAG", "Vector DB", "MLOps", "AI Agents",
];

const HERO_CLIENTS = [
  { name: "AIG", logo: "logos/aig.svg" },
  {name: "Surecomp", logo: "logos/surecomp-logo.png" },
  { name: "A", logo: "logos/a.svg" },
  { name: "Alma Security", logo: "logos/alma.svg" },
  { name: "Truvify", logo: "logos/Truvify.png" },
  { name: "Bot Authority", logo: "logos/Bot Authority.png" },
  { name: "Admonis", logo: "logos/admonis.png" },
  { name: "Ofek", logo: "logos/ofek.png" },
  { name: "Sharan Medical", logo: "logos/sharan medical.png" },
  { name: "MTF Security", logo: "logos/mtf.png" },
  { name: "Hippocampus", logo: "logos/hippo.svg" },
];


export default function Hero() {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setIdx((i) => (i + 1) % ROTATING_WORDS.length), 2200);
    return () => clearInterval(id);
  }, []);

  return (
    <section id="hero" className="hero">
      <div className="hero__bg">
        {FLOATING_TAGS.map((tag, i) => (
          <span
            key={tag}
            className="hero__tag"
            style={{
              left: `${(i * 53) % 85}%`,
              top: `${(i * 37) % 90}%`,
              animationDelay: `${(i % 9) * 0.45}s`,
            }}
          >
            {tag}
          </span>
        ))}
      </div>

      <div className="hero__content">
        <span className="hero__pill">
          <span className="hero__pill-dot" />
          Full-time DevOps &amp; AI engineering team
        </span>

        <h1 className="hero__title">
          We Engineer<br />
          <span className="hero__rotator-wrap">
            <span className="hero__rotator-prefix">End-to-End&nbsp;</span>
            <span className="hero__rotator" key={idx}>
              {ROTATING_WORDS[idx]}
            </span>
          </span>
        </h1>

        <p className="hero__subtitle">
          From cloud architecture and CI/CD pipelines to FinOps, observability, and
          intelligent AI agent systems - we ship production-grade platforms that
          scale, save cost, and keep teams shipping fast.
        </p>

        <div className="hero__cta">
          <a href="#contact" className="btn-primary-mod">
            Start Your Project
            <span className="mdi mdi-arrow-right" />
          </a>
          <a href="#services" className="btn-ghost-mod">
            Explore Services
          </a>
        </div>

        <div className="hero__clients">
          <span className="hero__clients-label">Trusted by</span>
          <div className="hero__clients-marquee">
            <Marquee gradient={false} speed={35} pauseOnHover autoFill>
              {HERO_CLIENTS.map((c) => (
                <img
                  key={c.name}
                  src={c.logo}
                  alt={c.name}
                  title={c.name}
                  className="hero__client-logo"
                />
              ))}
            </Marquee>
          </div>
        </div>
      </div>
    </section>
  );
}
